module.exports = __webpack_public_path__ + "img/28n.9d553a67.png";